import React from 'react'
import GenericCustomButton from '../GenericCustomButton';

const GenericFormFooterComponent = (props) => {

    const {buttons, leftButtons = [], isTopBorderRequired=false, leftComponent=null, spreadFormFotterExtraClass = ""} = props;

    return (
        <React.Fragment>
            <div className={`generic-form-footer ${isTopBorderRequired ? 'border-t border-[#D6D9E4]' : ''} ${spreadFormFotterExtraClass}`}>
                {/* {leftComponent && leftComponent?.()} */}
                {/* The buttons div always aligned at the right bottom of the modal */}
                <div>
                    {leftComponent ? typeof leftComponent === 'function' ? leftComponent() : leftComponent : null}
                    {leftButtons?.length > 0 && leftButtons?.map((item, index) => {
                            return <>
                                <GenericCustomButton
                                    sendEventAnalyticsToGoogle = { item?.hasOwnProperty("sendEventAnalyticsToGoogle") ? item?.sendEventAnalyticsToGoogle : true}
                                    {...item}
                                />
                            </>
                        })}
                </div>
                <div className='gff-right'>
                    {/* Render all the buttons data */}
                    {buttons?.map((item, index) => {
                        return <>
                            <GenericCustomButton
                                sendEventAnalyticsToGoogle = { item?.hasOwnProperty("sendEventAnalyticsToGoogle") ? item?.sendEventAnalyticsToGoogle : true}
                                {...item}
                            />
                        </>
                    })}
                </div>
            </div>
        </React.Fragment>
    )
}

export default GenericFormFooterComponent